import type { Directory } from '@archipro-website/top-navigation';

export const useEnquiryForm = (directory: Directory | undefined) => {
    const renderBranchOptions =
        directory && !['article', 'project'].includes(directory);

    return { renderBranchOptions };
};
